import { Avatar, Divider, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Navigate, useNavigate } from "react-router";
import { hideLoader, showLoader } from "../../Store/mainSlice";
import { useDispatch, useSelector } from "react-redux";
import httpClient from "../../_util/api";
import CustomizedSnackbars from "../../shared-component/Snackbar/SnackBar";
import { ConnectedTvOutlined } from "@mui/icons-material";

const Profile = () => {
  const navigate = useNavigate();
  const id = localStorage.getItem("userId");
  const firstName = localStorage.getItem("firstName");
  const isAdmin = JSON.parse(localStorage.getItem("isAdmin"));
  const isFinanceUser = JSON.parse(localStorage.getItem("isFinanceUser"));
  const agentTitle = localStorage.getItem("agentTitle");
  const profilePic = localStorage.getItem("profilePic");
  const dispatch = useDispatch();
  const snackbar_Ref = useRef();
  const isLoggedIn = useSelector((state) => state.mainSlice.isLoggedIn);

  useEffect(() => {
    console.log("profilePic", profilePic);
    console.log("agentTitle", agentTitle);
    console.log("isAdmin", isAdmin);
  }, []);

  return (
    <div className="header-profile">
      <CustomizedSnackbars ref={snackbar_Ref} />
      <Stack
        direction="row"
        alignItems="center"
        spacing={1.5}
        sx={{ minWidth: 0 }}
      >
        {profilePic ? (
          <Stack
            sx={{
              width: "40px",
              height: "40px",
              borderRadius: "20px",
              border: "2px solid #F08613",
            }}
          >
            <img
              src={profilePic}
              style={{ width: "100%", height: "100%", borderRadius: "50px" }}
              onClick={() =>
                navigate(
                  isAdmin ? "/adminAccountDetails" : "/agentAccountDetails"
                )
              }
            />
          </Stack>
        ) : (
          <Avatar
            variant="rounded"
            onClick={() =>
              navigate(
                isAdmin ? "/adminAccountDetails" : "/agentAccountDetails"
              )
            }
          />
        )}
        {/* <Avatar onClick={() => navigate(isAdmin ? "/adminAccountDetails" :"/agentAccountDetails")} /> */}
        <Stack
          direction="row"
          alignItems="center"
          sx={{ minWidth: 0, gap: 1 }}
        >
          <Stack
            flexDirection="row"
            sx={{ minWidth: 0, alignItems: "center" }}
          >
            <Typography
              noWrap
              sx={{
                marginRight: "10px",
                fontWeight: 700,
                fontSize: { xs: 14, sm: 18 },
                maxWidth: { xs: 88, sm: 160 },
              }}
            >
              {firstName}
            </Typography>
            {/* <Divider
              orientation="vertical"
              flexItem
              sx={{
                backgroundColor: "white",
                width: "1px",
                marginRight: "4px",
              }}
            /> */}
            <Typography
              className="profile-role"
              noWrap
              sx={{ marginRight: "4px", fontSize: { xs: 12, sm: 16 } }}
            >
              {isAdmin ? "Admin" : isFinanceUser ? "Finance" : agentTitle}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
};

export default Profile;
